export default "__VITE_ASSET__DWFBPFWR__"